import { BaSeInput } from "@base/react"
import { formatCurrency } from "../../services/utils"

export default function InputPercentage({
                                          name,
                                          value,
                                          onFnExternalChange,
                                          onFnExternalBlur,
                                          label,
                                          placeholder,
                                          subLabel,
                                          maxLength = 9,
                                          maxValue = 100,
                                          allowNegative = false,
                                          inputStatus = "",
                                          ...props
                                        }) {

  const maskPercentage = (event) => {
    const value = event.target.value
    const hasNegativeSign = value.includes("-")

    const onlyDigits = value
      .replace("-", "")
      .split("")
      .filter((s) => /\d/.test(s))
      .join("")
      .padStart(3, "0")

    const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2)

    let valorFloat = parseFloat(digitsFloat)

    if (hasNegativeSign) {
      valorFloat = Math.min(valorFloat, 100.0)
      valorFloat *= -1
    }

    if (hasNegativeSign) {
      valorFloat = Math.min(valorFloat, 100.0) * -1
    }

    let formatedValue = formatCurrency(Math.abs(valorFloat).toFixed(2))

    if (hasNegativeSign) {
      formatedValue = `-${formatedValue}`
    }

    return event.target.value = formatedValue
  }
  const handleInputChange = (e) => {
    let numericValue = parseFloat(e.replace(",", "."))
    if (isNaN(numericValue)) numericValue = 0
    if (numericValue > maxValue) numericValue = maxValue
    const formattedValue = numericValue.toFixed(2).replace(".", ",")
    if (onFnExternalChange) {
      onFnExternalChange(formattedValue)
    }
    return formattedValue
  }
  const handleInputBlur = (e) => {
    if (onFnExternalBlur) {
      onFnExternalBlur(e)
    }
  }

  return (
    <div className={`wrapper-input ${inputStatus}`}>
      <BaSeInput
        name={name}
        value={value}
        onInput={ allowNegative ? maskPercentage : null}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        label={label}
        placeholder={placeholder || "%"}
        subLabel={subLabel}
        inputStatus={inputStatus}
        size="medium"
        width="100%"
        inputMode="decimal"
        typeInput="tel"
        mask="decimal"
        maxLength={maxLength}
        {...props}
      />
    </div>
  )
}
